import React, {useState} from "react";
import {Formik, Form, Field} from "formik";
import * as Yup from "yup";
import Modal from "react-modal";
import "./proposalStyle.css";
import {proposalStatus} from "../../../utils/constants";

const dateToday = new Date().setHours(0, 0, 0, 0);
// Validation Schema using Yup
const ProposalSchema = Yup.object().shape({
  title: Yup.string().required("Titre est requis"),

  appointmentDate: Yup.date()
    .transform((value, originalValue) => {
      return originalValue ? new Date(originalValue) : null;
    })
    .test(
      "is-valid-date",
      "Date du RDV invalide",
      (value) => value instanceof Date && !isNaN(value)
    )
    .required("Date du RDV est requise")
    .min(
      new Date().setHours(0, 0, 0, 0),
      "La date du RDV doit être aujourd'hui ou ultérieure"
    ),

  appointmentTime: Yup.string()
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, "L'heure doit être au format HH:mm")
    .required("L'heure est requise")
    .test(
      "is-future-time",
      "L'heure doit être ultérieure à l'heure actuelle lorsque la date est aujourd'hui",
      function (value) {
        const {appointmentDate} = this.parent;
        if (!appointmentDate || !value) return true;

        const today = new Date();
        const selectedDate = new Date(appointmentDate);

        if (
          selectedDate.getFullYear() !== today.getFullYear() ||
          selectedDate.getMonth() !== today.getMonth() ||
          selectedDate.getDate() !== today.getDate()
        ) {
          return true;
        }

        const [hours, minutes] = value.split(":").map(Number);
        const combinedDateTime = new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
          hours,
          minutes
        );

        return combinedDateTime > today;
      }
    ),

  initialPrice: Yup.number()
    .typeError("Prix initial doit être un nombre")
    .required("Prix initial est requis"),

  comment: Yup.string().optional(),
});

// Custom styles for the modal
const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", // Enables flexbox
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically
  },
  content: {
    position: "relative",
    width: "100%",
    maxWidth: "554px", // Controls modal width
    maxHeight: "90vh", // Ensures it doesn't exceed the viewport height
    margin: "auto", // Centers in case of fallback
    borderRadius: "12px",
    padding: "48px",
    overflow: "auto", // Enables scroll for overflowing content
  },
};

const RecapModal = ({isOpen, onClose, onSubmit, onPayment, initialValues}) => (
  <Modal
    className={"h-fit bg-white z-999 "}
    isOpen={isOpen}
    onRequestClose={onClose}
    style={modalStyles}
  >
    <div className="flex flex-col justify-start w-full h-fit">
      <h2 className="text-[26px] leading-6 text-[#FF6600] w-full text-center font-bold  mb-4">
        Récapitulatif de la proposition
      </h2>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <div className="text-[#3D4465] font-normal text-sm">Titre</div>
          <div className="text-[#19295C] font-semibold text-sm">
            {initialValues.title}
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-[#3D4465] font-normal text-sm">Date du RDV</div>
          <div className="text-[#19295C] font-semibold text-sm">
            {initialValues.appointmentDate}
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-[#3D4465] font-normal text-sm">
            Adresse de l’intervention
          </div>
          <div className="text-[#19295C] font-semibold text-sm">
            {initialValues.adresse}
          </div>
        </div>

        <div className="flex flex-col gap-1">
          <div className="text-[#3D4465] font-normal text-sm">Prix proposé</div>
          <div className="text-[#19295C] font-semibold text-sm">
            {initialValues.initialPrice} €
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-[#3D4465] font-normal text-sm break-all">
            Commentaire
          </div>
          <div className="text-[#19295C] font-semibold text-sm break-all">
            {initialValues.comment}
          </div>
        </div>
      </div>
      <div className="flex justify-center w-full mt-6 gap-4">
        <button
          onClick={onClose}
          className="w-1/2   text-sm flex justify-center items-center !py-3 px-2 min-w-[100px]  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid"
        >
          Annuler
        </button>
        {initialValues.status === proposalStatus.ACCEPTED ? (
          <button
            onClick={onPayment}
            data-testid="proposal-payment-confirm"
            className="w-1/2 text-sm flex justify-center items-center py-3 px-2 min-w-[100px] !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white"
          >
            Procéder au paiement
          </button>
        ) : (
          <button
            onClick={onSubmit}
            data-testid="proposal-accept-confirm"
            className="w-1/2 text-sm flex justify-center items-center py-3 px-2 min-w-[100px]  !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
          >
            Accepter la proposition
          </button>
        )}
      </div>
    </div>
  </Modal>
);

export default RecapModal;
